import { render, staticRenderFns } from "./dailyStatistics.vue?vue&type=template&id=9780464e&scoped=true&"
import script from "./dailyStatistics.vue?vue&type=script&lang=js&"
export * from "./dailyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dailyStatistics.vue?vue&type=style&index=0&id=9780464e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780464e",
  null
  
)

export default component.exports